export enum CommunicationsResponseCreateOutboundCallError {}
